import React, { useEffect, useState } from 'react';
import { PiCheckCircleLight } from 'react-icons/pi';
import BrandLoader from '../brand/BrandLoader';

interface MiniLoadingToCheckmarkProps {
  isLoading: boolean;
  spinnerSize?: number;
  checkSize?: number;
  transitionDuration?: number;
}

/**
 * Small in-flight → done status icon. In-flight renders the brand
 * ring-draw loader; done renders a quiet success check.
 */
const MiniLoadingToCheckmark: React.FC<MiniLoadingToCheckmarkProps> = ({
  isLoading,
  spinnerSize = 16,
  checkSize = 16,
  transitionDuration = 300,
}) => {
  const [phase, setPhase] = useState<'SPINNING' | 'CHECKMARK'>(
    isLoading ? 'SPINNING' : 'CHECKMARK'
  );

  useEffect(() => {
    if (isLoading) {
      setPhase('SPINNING');
    } else {
      const timer = setTimeout(() => {
        setPhase('CHECKMARK');
      }, transitionDuration);

      return () => clearTimeout(timer);
    }
  }, [isLoading, transitionDuration]);

  return (
    <div
      className="relative flex items-center justify-center"
      style={{ width: checkSize, height: checkSize }}
    >
      <div
        className={`
          ${phase === 'SPINNING' ? 'opacity-100 scale-100' : 'opacity-0 scale-0'}
          absolute transition-all duration-300
          flex items-center justify-center
        `}
        style={{ width: spinnerSize, height: spinnerSize }}
      >
        <BrandLoader size="xs" className="!w-full !h-full" />
      </div>

      <PiCheckCircleLight
        className={`
          text-success transition-all duration-300
          ${phase === 'CHECKMARK' ? 'opacity-100 scale-100' : 'opacity-0 scale-0'}
        `}
        style={{ width: checkSize, height: checkSize }}
      />
    </div>
  );
};

export default MiniLoadingToCheckmark;
